// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3ozBV","col":"styles_col__3k0jM"};